var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('qr-code-device-public-info',{staticClass:"my-5",attrs:{"device":_vm.device}}),_c('base-button',{attrs:{"is_accent":true,"to":_vm.viewDeviceUrl,"text":"Go to the device page"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }